import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
    tagRecord: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        tag: PropTypes.string.isRequired,
        description: PropTypes.string,
    }),
    onSelectTag: PropTypes.func,
    selected: PropTypes.bool,
};

const defaultProps = {
    className: '',
    onSelectTag: null,
    selected: false,
};

function NewTagTableRow(props) {
    return (
        <li className={`tagRow ${props.className}`}>
            <label className="tagCol" htmlFor={`tag-select-${props.tagRecord.id}`}>
                {props.tagRecord.tag}
            </label>
            <div className="tagCol tagDescription">
                {!!props.tagRecord &&
                    props.tagRecord.description
                }
            </div>
            {!!props.onSelectTag &&
                <div className="tagCol__control">
                    <input
                        id={`tag-select-${props.tagRecord.id}`}
                        type="checkbox"
                        checked={props.selected}
                        onChange={props.onSelectTag}
                    />
                </div>
            }
        </li>
    );
}

NewTagTableRow.propTypes = propTypes;
NewTagTableRow.defaultProps = defaultProps;

export default NewTagTableRow;